import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Box }  from '@chakra-ui/react';

const Timer = () => {

     const [seconds, setSeconds] = useState(0);
        const [isRunning, setIsRunning] = useState(false);
      
        // Retrieve the countdown time from cookies when the page loads
        useEffect(() => {
          const countdownTime = Cookies.get('countdownTime');
          if (countdownTime) {
            setSeconds(parseInt(countdownTime, 10));  // Use as seconds
            setIsRunning(true);
          }
        }, []);
      
        // Countdown logic
        useEffect(() => {
          let timer;
          if (isRunning && seconds > 0) {
            timer = setInterval(() => {
              setSeconds((prevSeconds) => {
                const updatedSeconds = prevSeconds - 1;
                Cookies.set('countdownTime', updatedSeconds);  // Update cookie
                return updatedSeconds;
              });
            }, 1000);
          } else if (seconds <= 0) {
            clearInterval(timer);
            Cookies.remove('countdownTime');  // Clear the cookie when finished
          }
      
          return () => clearInterval(timer);
        }, [isRunning, seconds]);
      
        // Format seconds into mm:ss
        const formatTime = (secs) => {
          const minutes = Math.floor(secs / 60);
          const remainingSeconds = secs % 60;
          return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
        };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bg="gray.100" // Optional: background color for better visibility
    >
      <Box textAlign="center">
        <h2 style={{ fontSize: '8rem', fontWeight: 'bold' }}>{formatTime(seconds)}</h2>
        {!isRunning && seconds === 0 && <p style={{ fontSize: '2rem' }}>Time's up!</p>}
      </Box>
    </Box>
  );
};

export default Timer;
